/**
 * @generated SignedSource<<17253bf892080c1defc0fa78a5f3a068>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type resolution_nativeIssueTable_ResolutionCell$data = {
  readonly id?: string;
  readonly resolution: {
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "resolution_nativeIssueTable_ResolutionCell";
};
export type resolution_nativeIssueTable_ResolutionCell$key = {
  readonly " $data"?: resolution_nativeIssueTable_ResolutionCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"resolution_nativeIssueTable_ResolutionCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "resolution_nativeIssueTable_ResolutionCell",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "concreteType": "JiraResolution",
      "kind": "LinkedField",
      "name": "resolution",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraResolutionField"
};

(node as any).hash = "beb592d5c9992aa347f2c7b6b31262c0";

export default node;
